import { render, staticRenderFns } from "./MoonLoader.vue?vue&type=template&id=8cdaba4c&"
import script from "./MoonLoader.vue?vue&type=script&lang=js&"
export * from "./MoonLoader.vue?vue&type=script&lang=js&"
import style0 from "./MoonLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports